// extracted by css-extract-rspack-plugin
export default {"icon":"OU4uJ","root":"imaaZ"};